const TOGGLE_DEBUG_MODE = 'TOGGLE_DEBUG_MODE'

const initialState = {
  debugMode: localStorage.getItem('debug_mode') === 'true',
}

export default {
  namespaced: true,
  state: initialState,

  getters: {
    inDebugMode: state => state.debugMode
  },

  mutations: {
    [TOGGLE_DEBUG_MODE] (state, enabled) {
      state.debugMode = enabled
    }
  },

  actions: {
    /**
     * Enable / Disable debug mode
     * You need to be an Everli developer to get benefits of this
     */
    toggleDebugMode ({ commit, state }) {
      localStorage.setItem('debug_mode', !state.debugMode)

      commit(TOGGLE_DEBUG_MODE, !state.debugMode)
    }
  }
}
